import React, { PureComponent } from "react";

import bassClefHeader from "../img/bass-clef-header.svg";
import Routes from "../routes/Routes";

import facebookLogo from "./facebook-logo.svg";
import instagramLogo from "./instagram-logo.svg";

class App extends PureComponent {
  render() {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row"
        }}
      >
        <div
          style={{
            maxWidth: 800,
            margin: "auto",
            flexGrow: 1,
            alignItems: "center"
          }}
        >
          <div
            style={{
              margin: 0,
              padding: 0,
              backgroundColor: "#333",
              color: "white",
              flex: 1,
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              alignItems: "center",
              height: 50
            }}
          >
            <div
              style={{
                marginLeft: 10,
                marginRight: 10
              }}
            >
              <img
                alt="MarkAllan.us"
                src={bassClefHeader}
                color="white"
                style={{
                  height: 30,
                  fillColor: "white"
                }}
              />
            </div>

            <div>
              <h1>MarkAllan.us</h1>
            </div>
          </div>

          <Routes />

          {/* footer */}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <div>
              <a
                href="https://www.facebook.com/mark.a.courtney"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  style={{
                    width: 48,
                    margin: 5
                  }}
                  alt="Facebook logo"
                  src={facebookLogo}
                />
              </a>
            </div>

            <div>
              <a
                href="https://www.instagram.com/markallan.us/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  style={{
                    width: 48,
                    margin: 5
                  }}
                  alt="Instagram logo"
                  src={instagramLogo}
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/Page/Page.js